<template>
	<span class="shp">
			<b-modal v-if="iamin=='sharelinkpage'" id="showShareModal" hide-footer body-class="bodypaddingtop" no-close-on-backdrop>
			<template #modal-title> Selected Products</template> 
			 <template #modal-header>
      		  
			  <h5 class="modal-title"> Selected Products </h5>
			 
			  <button type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModal')" class="close">×</button>
			</template>
			
			  
					<p class="m-1"><small>Shared link : </small><small class="font-weight-light">https://www.alluraa.com/share/{{selectedLink}}</small></p>
					<b-container fluid class="p-1">					
					<!-- {{cartItems}} -->
						
						<div class="card" :key="item.id" v-for="item in selectedItem">
							<!-- <header class="card-header">featured</header> -->
							<div class="card-body">
								<b-row>
									<b-col cols="3" sm="3" md="3" lg="3">
										<b-link :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
									</b-col>
									<b-col cols="7" sm="7" md="7" lg="7">
										<span class="pTitle">{{item.title}}</span>
										<ul class="p-0 m-0 shoppopup">
											<li v-if="item.short_description!=''"><small>{{item.short_description}}</small></li>
											<li >
												<small>Price: </small>
												<span v-if="item.special_price>0 && item.special_price!=null">
												 <del class="spCross">{{$root.currency()+$root.tofixed((item.price ), 2)}}</del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price), 2)}}</small>
											   
												</span>
												<span v-else>
													<small class="my-0" >{{$root.currency()+$root.tofixed((item.price), 2)}}</small>
												</span>
											</li>
											<li ><small>Commission: </small> {{item.commission}}%</li>
											<li class="sharepopupStardiaplay" ><product-rating :userrating="item.total_rating"></product-rating></li>
										</ul>
										
										
										
										
									</b-col>
									<b-col cols="1" sm="2" md="1" lg="1">
										<b-link  v-if="selectedLink==''" disabled><i class="fa fa-trash" aria-hidden="true"></i></b-link>
									</b-col>
								</b-row>
								
							</div>
							
						</div>

					
					</b-container>
			  <b-container fluid class="p-1">
			  
			 
			  <small>
			  <b-form-group label="Select Message" v-slot="{ ariaDescribedby }" class="mb-0 myoption">
			  <b-form-radio-group
				id="radio-slots"
				v-model="selected"
				:options="options"
				:aria-describedby="ariaDescribedby"
				name="radio-options-slots"				
				v-on:change="changeMessage"
			  >
			
			  </b-form-radio-group>
			</b-form-group>
			</small>
			<p class="m-0 text-center"><small class="noteMess font-weight-light">(Edit to send personalised messages)</small></p>
		<!--<div>Selectedd: {{selectedmess}}</div> -->
			  
			  </b-container>
			  <div class="message-textarea-wrapper">
				<b-form-textarea v-model="linkComments"
				  id="message-textarea"
				  rows="4"
				  placeholder="Type your message here"
				></b-form-textarea>
			  </div>
			  <div
				class="product-share-wrapper d-flex justify-content-center align-items-ceter mt-3">
				<span class="product-share-txt align-self-center mr-4 sharepopupName">Share Now</span>
					<!-- {{selectedLink}}
					{{linkComments}} -->
						<b-row class="float-right">
							<b-col class="socialIconAll">
								<!--<div class="" @click="shareSelectedProducts(selectedItem, 'sms')">
									<img src="@/assets/sms.svg" width="30px;" />
								</div> -->
								<div>
									<ShareNetwork
										network="email"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										@open="$root.onShareClick(selectedLink,'Email')">
										<img src="@/assets/sms.svg" width="30px;" />
									</ShareNetwork>
								</div>
								
								
								<div >
									<ShareNetwork
										network="facebook"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										:quote="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Facebook')">
										<img src="@/assets/facebook.svg"/>
									</ShareNetwork>
									<!--:quote="linkComments"-->
								</div>
								<div >
									<ShareNetwork
										network="whatsapp"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Whatsapp')" >
										<img src="@/assets/whatsapp.svg"/>
									</ShareNetwork>
								</div>
								<div >
									<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										:title="'Alluraa Product. '+linkComments"
										hashtags="Alluraa"
										twitter-user=""
										@open="$root.onShareClick(selectedLink,'Twitter')">
										<img src="@/assets/twitter.svg"/>
									</ShareNetwork>
									
									
								</div>
								<div >
								<ShareNetwork
										network="telegram"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Product"
										:description="linkComments"
										@open="$root.onShareClick(selectedLink,'Telegram')"
										>
										<img src="@/assets/telegram.svg" />
									</ShareNetwork>
								</div>
							</b-col>
						</b-row>
			  </div>
			</b-modal>
			<b-modal v-if="iamin=='sharelinkcart'" id="showShareModalcart" hide-footer body-class="bodypaddingtop" no-close-on-backdrop>
			  <!-- <template #modal-title> Selected Products</template> -->
			  <template #modal-header>      		  
			  <h5 class="modal-title"> Selected Products </h5>			 
			  <button type="button" aria-label="Close" @click="$root.closeMeShareModel('showShareModalcart')" class="close">×</button>
			</template>
					<p class="m-1"><small>Shared link : </small><small class="font-weight-light">https://www.alluraa.com/share/{{selectedLink}}</small></p>
			  		<b-container fluid class="p-1">					
					<!-- {{cartItems}} -->
						<!-- p>Link<small><b-link :href="'https://www.alluraa.com/share/'+selectedLink" style="color: #5b297a;" target="_blank">https://www.alluraa.com/share/{{selectedLink}}</b-link></small></p> -->
						
						<div class="card" :key="item.id" v-for="item in selectedItemcart">
							<!-- <header class="card-header">featured</header> -->
							<div class="card-body">
								<b-row>
									<b-col cols="3" sm="3" md="3" lg="3">
										<b-link :href="'/product/'+item.product_id"> <b-img  rounded alt="" :src="$root.MEDIAAPI+'toolimage/get_image?size=80x80&src='+item.image" class="pImg"></b-img></b-link>
									</b-col>
									<b-col cols="7" sm="7" md="7" lg="7">
										<span class="pTitle">{{item.title}}</span>
										<ul class="p-0 m-0 shoppopup">
											<li v-if="item.short_description!=''"><small>{{item.short_description}}</small></li>
											<li >
												<small>Price: </small>
												<span v-if="item.special_price>0 && item.special_price!=null">
												 <del class="spCross">{{$root.currency()+$root.tofixed((item.price ), 2)}}</del> <small class="my-0" >{{$root.currency()+$root.tofixed((item.special_price), 2)}}</small>
											   
												</span>
												<span v-else>
													<small class="my-0" >{{$root.currency()+$root.tofixed((item.price), 2)}}</small>
												</span>
											</li>
											<li ><small>Commission: </small> {{item.commission}}%</li>
											
											<li class="sharepopupStardiaplay"><product-rating :userrating="item.total_rating"></product-rating></li>
										</ul>
									</b-col>
									<b-col  cols="1" sm="1" md="1" lg="1">
										<b-link v-if="selectedLink==''"  disabled><i class="fa fa-trash" aria-hidden="true"></i></b-link>
									</b-col>
								</b-row>
								
							</div>
							
						</div>

					
					</b-container>

			 <b-container fluid class="p-1">
			  
			 
			  <small>
			  <b-form-group label="Select Message" v-slot="{ ariaDescribedby }" class="mb-0 myoption">
			  <b-form-radio-group
				id="radio-slots"
				v-model="selected"
				:options="options"
				:aria-describedby="ariaDescribedby"
				name="radio-options-slots"				
				v-on:change="changeMessage"
			  >
			
			  </b-form-radio-group>
			</b-form-group>
			</small>
			
		<!--<div>Selectedd: {{selectedmess}}</div> -->
			  <p class="m-0 text-center"><small class="noteMess font-weight-light">(Edit to send personalised messages)</small></p>
			  </b-container>
			  <div class="message-textarea-wrapper">
				<b-form-textarea v-model="linkComments"
				  id="message-textarea"
				  rows="3"
				  placeholder="Type your message here"
				></b-form-textarea>
			  </div>
			<div v-if="$root.share.iamiconfor=='allnetwork'"
				class="product-share-wrapper d-flex justify-content-center align-items-ceter mt-3">
				<span class="product-share-txt align-self-center mr-4 sharepopupName">Share Now</span>
					<!-- {{selectedLink}}
					{{linkComments}} -->
						<b-row class="float-right">
							<b-col class="socialIconAll">
								<div>
									<ShareNetwork
										network="email"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										@open="$root.onShareClick(selectedLink,'Email')" >
										<img src="@/assets/sms.svg" width="30px;" />
									</ShareNetwork>
								</div>
								
								<div > 
									<ShareNetwork
										network="facebook"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										:quote="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Facebook')">
										<img src="@/assets/facebook.svg"/>
									</ShareNetwork>
								</div>
								<div >
									<ShareNetwork
										network="whatsapp"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Whatsapp')" >
										<img src="@/assets/whatsapp.svg"/>
									</ShareNetwork>
								</div>
								<div >
									<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										:title="'Alluraa Product. '+linkComments"
										hashtags="Alluraa"
										twitter-user=""
										:description="linkComments"
										@open="$root.onShareClick(selectedLink,'Twitter')"
										>
										<img src="@/assets/twitter.svg"/>
									</ShareNetwork>
								</div>
								<div >
								<ShareNetwork
										network="telegram"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Product"
										:description="linkComments"
										@open="$root.onShareClick(selectedLink,'Telegram')"
										>
										<img src="@/assets/telegram.svg" />
									</ShareNetwork>
								</div>
							</b-col>
						</b-row>
			  </div>
			  <div v-else
				class="product-share-wrapper d-flex justify-content-center align-items-ceter mt-3">
				<!-- <span class="product-share-txt align-self-center mr-4">Share Now</span> -->
					<!-- {{selectedLink}}
					{{linkComments}} -->
						<b-row class="float-right">
							<b-col>
								<!--<div class="icon-btn float-left margin-right-half" @click="shareSelectedProducts(selectedItem, 'sms')">
									<img src="@/assets/sms.svg"/>
								</div> -->
								<!-- <b-button  v-if="$root.share.iamiconfor=='sms'" variant="dark" pill class="mr-2" @click="shareSelectedProducts(selectedItem, 'sms')">
								<img src="@/assets/sms.svg" width="20px;"/> Share Now
								</b-button> -->
								
								
									
									<b-button  v-if="$root.share.iamiconfor=='sms'" variant="dark" pill class="mr-2">
										<ShareNetwork
											network="email"
											:url="'https://www.alluraa.com/share/'+selectedLink"
											title="Alluraa Products"
											:description="linkComments"
											hashtags="Alluraa"
											@open="$root.onShareClick(selectedLink,'Email')">
											<img src="@/assets/sms.svg" width="20px;" /> Share Now
										</ShareNetwork>
									</b-button>
								
								
								<b-button  v-if="$root.share.iamiconfor=='facebook'" variant="dark" pill class="mr-2"><ShareNetwork
										network="facebook"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments"
										hashtags="Alluraa"
										:quote="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Facebook')"
										>
										<img src="@/assets/facebook.svg" width="20px;"/> Share Now
									</ShareNetwork> </b-button>
								
								<b-button   v-if="$root.share.iamiconfor=='whatsapp'" variant="dark" pill class="mr-2">
									<ShareNetwork
										network="whatsapp"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Products"
										:description="linkComments +' https://www.alluraa.com/share/'+selectedLink"
										@open="$root.onShareClick(selectedLink,'Whatsapp')">
										<img src="@/assets/whatsapp.svg" width="20px;"/> Share Now
									</ShareNetwork>
								</b-button>
								<b-button  v-if="$root.share.iamiconfor=='twitter'" variant="dark" pill class="mr-2">
									<ShareNetwork
										network="twitter"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										:title="'Alluraa Product. '+linkComments"
										hashtags="Alluraa"
										twitter-user=""
										@open="$root.onShareClick(selectedLink,'Twitter')" >
										<img src="@/assets/twitter.svg" width="20px;"/> Share Now
									</ShareNetwork>
								</b-button>
								<b-button  v-if="$root.share.iamiconfor=='telegram'" variant="dark" pill class="mr-2">
									<ShareNetwork
										network="telegram"
										:url="'https://www.alluraa.com/share/'+selectedLink"
										title="Alluraa Product."
										:description="linkComments"
										@open="$root.onShareClick(selectedLink,'Telegram')"
										>
										<img src="@/assets/telegram.svg" width="20px;"/> Share Now
									</ShareNetwork>
								</b-button>
							</b-col>
						</b-row>
			  </div>
			</b-modal>

		</span>		
</template>
<script>
//import CartVariant from "@/components/cartVariant.vue";
import ProductRating from "@/components/product-rating.vue";
export default {
  name: 'SharelinkPopup',
  components: {
  //"cart-variant": CartVariant,
  "product-rating": ProductRating,
  },
  props: { 
	selectedItem: { type: Object},
	selectedItemcart: { type: Array},
	selectedLink:String,
	iamin:String,
  },
  mounted(){
    this.inLodcard();
  },
  computed: {
    
  },
  data() {
    return{
		//urlSavebank:this.$root.WEBURL+'savebankProfile',
		linkComments:'',
		urlSavebank: this.$root.NEWAPIURL+'profileapi/save-bank',		
		thumbnailPropsPop: { blank: false, fluidGrow: true, width: 80, height: 80,class: 'm1' },
		social_options: {
            'facebook': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'instagram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'tweeter': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'whatsapp': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'telegram': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
            'sms': '“Alluraa” brings you exclusive offers only for you! Click the link to buy now! ',
        },
		selectedmess:'',
		selected: 'whatsapp',
        options: [
          { text: 'Message 1', value: 'whatsapp' },
          { text: 'Message 2', value: 'facebook' },
          { text: 'Message 3', value: 'tweeter' },
          //{ text: 'Message 4', value: 'telegram' },
         // { text: 'Message 5', value: 'instagram' }
        ],
		iamiconfor:'',
    }
  },
  methods:{
	/* inLodcard(){
		alert('dasd');
	},*/
	inLodcard(){			
			this.linkComments = this.social_options[this.$root.share.social];
		},
		changeMessage(arg){		 
            //console.log('CHANGE MESSAGE '+social_options[$root.share.social]);
            this.linkComments = this.social_options[arg];
			
        },

    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style    lang="scss">
.spCross{
font-size: 12px !important;
	color: darkgray;
	}
.shp{
.spCross{
	font-size: 12px !important;
	color: darkgray;
	}
}
		$whiteColor: #ffffff;
		$blackColor: #000000;
		$themeColor: #a059d9;
		$themeColor2: #8507d6;
		$themeColor3: #b24bf1;
		$redColor: #e61583;
		$grey: #b9b9b9;
		$grey2: #a6a6a6;
		$themeLightColor: #f2e2ff;
		$themeDarkColor: #df007e;

		@mixin setBlackBoldTextStyles() {
		  font-size: 12px;
		  color: $blackColor;
		  font-weight: bold;
		}
	
		#showShareModal {
		.modal-header{
		padding: 8px;
		}
		
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}
	#showShareModalcart {
		.modal-header{
		padding: 8px;
		}
	  .selected-products-wrapper {
		.product-wrapper {
		  width: 50%;
		  max-width: 300px;
		  margin-bottom: 45px;

		  .product-img-wrapper {
			width: 120px;
			text-align: center;

			img {
			  max-height: 100px;
			}
		  }

		  .product-content-wrapper {
			width: calc(100% - 120px);
			padding-left: 5px;

			.product-title {
			  @include setBlackBoldTextStyles();
			}

			.remove-product-link {
			  font-size: 14px;
			  color: $grey2;
			}
		  }
		}
	  }
	  .product-share-wrapper {
		margin-top: 24px;
	  }
	  .bodypaddingtop{
		
		padding-top:0px;
		}
	}

	#message-textarea {
	  border-color: $themeDarkColor;

	  :focus {
		border-color: $themeColor2;
	  }
	}
	
	.shoppopup>li{
	line-height:15px;
	}
	
	.card{
			margin-bottom: 12px;	
			box-shadow: 0px 0px 1px 0px #c6c6c6;
			
			.card-footer{
				background-color: #fff;
				border-top: 1px solid rgba(0,0,0,.125);
				.spCross{
					    font-size: 12px;
   						color: darkgray;
				}
			}

			.card-body{
				padding: 5px;
				.pImg{
					max-height: max-content;
				}

				.pTitle{
					font-size: smaller;
					font-weight: 200;
					color: #3f414d;
				}
			}
		}
		
		#radio-slots{
		    text-align: center;
			margin-left: 3%;
		}
		.myoption{
				.custom-control{				 
					margin-right: 20px !important;
					color: #515457d1;
				}
			/*.custom-control-inline{		 
				margin-right: 50px !important;
			}*/
		}
	
	.noteMess{
			font-size: 12px;
		}
		
		.sharepopupStardiaplay{ width: 37%;height: 13px;}

</style>
